// extracted by mini-css-extract-plugin
export default {"separator":"Separator-module__separator__3NwQH"};